import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

var initLegacy = function initLegacy() {
  function init() {
    return _init.apply(this, arguments);
  }

  function _init() {
    _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var templatesOpener;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import('../components/scripts/templates-opener.legacy');

            case 2:
              templatesOpener = _context.sent;
              templatesOpener["default"].init();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _init.apply(this, arguments);
  }

  init();
};

export default initLegacy;